var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _g3, _g4, _g5, _g6, _g7, _path8, _g8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 181,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#letter_svg__filter0_dddd_1265_1198)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154 125.467c0 4.387 0 6.58-.854 8.256a7.831 7.831 0 01-3.423 3.423c-1.676.854-3.869.854-8.256.854H25.533c-4.387 0-6.58 0-8.256-.854a7.832 7.832 0 01-3.423-3.423C13 132.047 13 129.854 13 125.467v-74.76c0-2.452 0-3.678.338-4.791.3-.985.79-1.902 1.444-2.698.738-.898 1.759-1.578 3.8-2.939l26.51-17.674c1.174-.782 1.761-1.174 2.396-1.45a7.833 7.833 0 011.76-.533c.681-.122 1.386-.122 2.797-.122h62.91c1.411 0 2.116 0 2.798.122a7.827 7.827 0 011.759.532c.635.277 1.222.669 2.395 1.451l26.512 17.674c2.04 1.36 3.061 2.04 3.799 2.94a7.829 7.829 0 011.444 2.697c.338 1.113.338 2.34.338 4.792v74.759z",
    fill: "url(#letter_svg__paint0_linear_1265_1198)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.49 125.467v.023c0 2.174 0 3.835-.109 5.161-.109 1.337-.331 2.376-.799 3.294a8.318 8.318 0 01-3.637 3.637c-.918.468-1.957.69-3.294.799-1.326.109-2.987.109-5.162.109H25.51c-2.174 0-3.835 0-5.162-.109-1.336-.109-2.375-.331-3.293-.799a8.323 8.323 0 01-3.637-3.637c-.468-.918-.69-1.957-.8-3.294-.108-1.326-.108-2.987-.108-5.162V50.611c0-2.36 0-3.654.36-4.837a8.321 8.321 0 011.534-2.866c.784-.956 1.861-1.673 3.825-2.982l.08-.054 26.512-17.674.045-.03c1.131-.754 1.751-1.168 2.426-1.462a8.323 8.323 0 011.87-.566c.724-.13 1.47-.13 2.828-.13H115.01c1.359 0 2.104 0 2.829.13.643.114 1.27.304 1.869.566.675.294 1.295.708 2.426 1.461l.045.03 26.511 17.675.081.053c1.964 1.31 3.04 2.028 3.825 2.983a8.318 8.318 0 011.534 2.866c.36 1.183.36 2.477.36 4.837v74.856z",
    stroke: "url(#letter_svg__paint1_linear_1265_1198)",
    strokeWidth: 0.979
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.467 137.021H25.533c-2.21 0-3.808-.001-5.065-.104-1.245-.101-2.07-.298-2.746-.643a6.857 6.857 0 01-2.996-2.995c-.345-.677-.542-1.501-.643-2.747-.103-1.257-.104-2.856-.104-5.065v-74.76c0-2.513.01-3.565.296-4.506a6.854 6.854 0 011.263-2.36c.625-.76 1.495-1.353 3.586-2.747L45.636 23.42c1.201-.801 1.706-1.134 2.243-1.368a6.862 6.862 0 011.54-.466c.577-.103 1.182-.107 2.626-.107h62.91c1.444 0 2.049.004 2.626.107.53.094 1.046.25 1.539.466.538.234 1.043.567 2.244 1.368l26.512 17.674c2.091 1.394 2.961 1.986 3.586 2.746a6.858 6.858 0 011.263 2.36c.286.942.296 1.994.296 4.508v74.759c0 2.209-.001 3.808-.104 5.065-.101 1.246-.298 2.07-.643 2.747a6.855 6.855 0 01-2.996 2.995c-.676.345-1.5.542-2.746.643-1.257.103-2.856.104-5.065.104zm11.679-3.298c.854-1.676.854-3.869.854-8.256v-74.76c0-2.452 0-3.678-.338-4.79a7.829 7.829 0 00-1.444-2.699c-.738-.898-1.759-1.578-3.799-2.939l-26.512-17.674c-1.173-.782-1.76-1.174-2.395-1.45a7.827 7.827 0 00-1.759-.533c-.682-.122-1.387-.122-2.798-.122h-62.91c-1.41 0-2.116 0-2.798.122a7.833 7.833 0 00-1.76.532c-.634.277-1.22.669-2.394 1.451L18.58 40.28c-2.04 1.36-3.06 2.04-3.8 2.94a7.835 7.835 0 00-1.443 2.697C13 47.03 13 48.256 13 50.708v74.759c0 4.387 0 6.58.854 8.256a7.832 7.832 0 003.423 3.423c1.676.854 3.87.854 8.256.854h115.934c4.387 0 6.58 0 8.256-.854a7.831 7.831 0 003.423-3.423z",
    fill: "#5B21B6",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#letter_svg__filter1_f_1265_1198)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.73 31.059a6.93 6.93 0 016.69-4.555l83.911 2.174a6.93 6.93 0 016.631 5.646l8.168 43.44c.81 4.308-2.535 8.277-6.918 8.209L28.123 84.297c-4.765-.074-8.035-4.824-6.403-9.301l16.01-43.937z",
    fill: "#3A0095",
    fillOpacity: 0.4
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.227.741a6.242 6.242 0 00-6.762 5.674l-8.107 92.667a6.243 6.243 0 005.674 6.763l89.741 7.851a6.242 6.242 0 006.762-5.674l8.107-92.667a6.242 6.242 0 00-5.674-6.763L43.228.741z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.227.741a6.242 6.242 0 00-6.762 5.674l-8.107 92.667a6.243 6.243 0 005.674 6.763l89.741 7.851a6.242 6.242 0 006.762-5.674l8.107-92.667a6.242 6.242 0 00-5.674-6.763L43.228.741z",
    fill: "url(#letter_svg__paint2_linear_1265_1198)",
    fillOpacity: 0.02,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.227.741a6.242 6.242 0 00-6.762 5.674l-8.107 92.667a6.243 6.243 0 005.674 6.763l89.741 7.851a6.242 6.242 0 006.762-5.674l8.107-92.667a6.242 6.242 0 00-5.674-6.763L43.228.741z",
    stroke: "url(#letter_svg__paint3_linear_1265_1198)",
    strokeWidth: 0.734
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.051 55.262L37.319 6.49a5.385 5.385 0 015.835-4.896l89.74 7.852a5.386 5.386 0 014.896 5.834l-4.694 53.65",
    stroke: "url(#letter_svg__paint4_linear_1265_1198)",
    strokeWidth: 0.734
  })), /*#__PURE__*/React.createElement("mask", {
    id: "letter_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: -2,
    width: 141,
    height: 140
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 50.708c0-2.453 0-3.679.338-4.792.3-.985.79-1.902 1.444-2.698.738-.898 1.759-1.578 3.8-2.939L76.547 1.635C79.06-.04 80.317-.878 81.674-1.203a7.834 7.834 0 013.651 0c1.358.325 2.615 1.163 5.127 2.838l57.967 38.644c2.04 1.36 3.061 2.04 3.799 2.94a7.829 7.829 0 011.444 2.697c.338 1.113.338 2.34.338 4.792v74.759c0 4.387 0 6.58-.854 8.256a7.831 7.831 0 01-3.423 3.423c-1.676.854-3.869.854-8.256.854H25.533c-4.387 0-6.58 0-8.256-.854a7.832 7.832 0 01-3.423-3.423C13 132.047 13 129.854 13 125.467v-74.76z",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#letter_svg__a)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#letter_svg__filter2_di_1265_1198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 44v94l47.907-37.09c4.36-3.374 6.539-5.062 7.323-7.115.688-1.8.688-3.79 0-5.59-.784-2.053-2.964-3.74-7.323-7.115L13 44z",
    fill: "url(#letter_svg__paint5_linear_1265_1198)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.02 42.004v97.992l54.287-42.028c4.557-3.528 4.557-10.408 0-13.936L12.021 42.004zM13 44l52.708 40.806c4.05 3.136 4.05 9.252 0 12.388L13 138V44zM154.912 42.004v97.992l-54.286-42.028c-4.557-3.528-4.557-10.408 0-13.936l54.286-42.028zM153.933 44l-52.708 40.806c-4.05 3.136-4.05 9.252 0 12.388L153.933 138V44z",
    fill: "#475569",
    fillOpacity: 0.06
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#letter_svg__filter3_di_1265_1198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154 44v94l-47.907-37.09c-4.359-3.374-6.539-5.062-7.323-7.115a7.834 7.834 0 010-5.59c.784-2.053 2.964-3.74 7.323-7.115L154 44z",
    fill: "url(#letter_svg__paint6_linear_1265_1198)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#letter_svg__filter4_f_1265_1198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.938 138h135.124L91.877 84.819c-2.961-2.661-4.442-3.992-6.116-4.496a7.834 7.834 0 00-4.522 0c-1.674.505-3.155 1.835-6.116 4.496L15.937 138z",
    fill: "#334155",
    fillOpacity: 0.4
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#letter_svg__filter5_f_1265_1198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.77 138H143.23l-50.4-56.183c-3.23-3.6-4.844-5.4-6.747-6.065a7.833 7.833 0 00-5.164 0c-1.903.664-3.518 2.464-6.748 6.065L23.77 138z",
    fill: "#334155",
    fillOpacity: 0.2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#letter_svg__filter6_f_1265_1198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.938 138h135.124L92.667 75.373c-3.187-3.418-4.78-5.126-6.642-5.76a7.833 7.833 0 00-5.05 0c-1.862.634-3.455 2.342-6.642 5.76L15.938 138z",
    fill: "#334155",
    fillOpacity: 0.1
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#letter_svg__filter7_i_1265_1198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 138h141L91.678 84.334c-2.901-2.499-4.352-3.748-5.98-4.224a7.834 7.834 0 00-4.396 0c-1.628.476-3.079 1.725-5.98 4.224L13 138z",
    fill: "url(#letter_svg__paint7_linear_1265_1198)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.469 136.042L75.2 83.924c2.945-2.527 4.417-3.79 6.069-4.272a7.956 7.956 0 014.457.003c1.65.483 3.122 1.748 6.064 4.279l61.719 53.087",
    stroke: "#475569",
    strokeOpacity: 0.06,
    strokeWidth: 0.979
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#letter_svg__filter8_f_1265_1198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 62.115V138h141V62.115",
    stroke: "url(#letter_svg__paint8_linear_1265_1198)",
    strokeWidth: 15.667
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13 47.917v77.55c0 4.387 0 6.58.854 8.256a7.832 7.832 0 003.423 3.423c1.676.854 3.87.854 8.256.854h115.934c4.387 0 6.58 0 8.256-.854a7.831 7.831 0 003.423-3.423c.854-1.676.854-3.869.854-8.256v-77.55",
    stroke: "#fff",
    strokeOpacity: 0.4,
    strokeWidth: 1.958,
    strokeLinecap: "round"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.014 29.265c1.894.166 3.308 1.845 3.143 3.731-.165 1.886-1.85 3.294-3.743 3.128-1.894-.165-3.308-1.844-3.143-3.73.165-1.886 1.85-3.294 3.743-3.128zm.141-1.613c-2.784-.244-5.261 1.826-5.504 4.6-.243 2.774 1.837 5.243 4.622 5.486 2.785.244 5.261-1.826 5.504-4.6.243-2.774-1.837-5.243-4.622-5.486z",
    fill: "#000"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.892 28.405l-3.907-.342a7.016 7.016 0 011.705 5.23 7.016 7.016 0 01-2.588 4.856l3.907.342c2.753.241 5.203-1.831 5.446-4.605.243-2.774-1.81-5.24-4.563-5.481z",
    fill: "#FFB224"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "letter_svg__paint0_linear_1265_1198",
    x1: 54.125,
    y1: 116.458,
    x2: 110.917,
    y2: 45.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "letter_svg__paint1_linear_1265_1198",
    x1: 83.5,
    y1: 138,
    x2: 83.5,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475569",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475569",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "letter_svg__paint2_linear_1265_1198",
    x1: 46.92,
    y1: 14.702,
    x2: 116.592,
    y2: 117.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9116C2",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#9A01D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#FF91CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "letter_svg__paint3_linear_1265_1198",
    x1: 88.066,
    y1: 5.032,
    x2: 78.934,
    y2: 109.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#422C84",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475569",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "letter_svg__paint4_linear_1265_1198",
    x1: 138.789,
    y1: 9.47,
    x2: 69.43,
    y2: 77.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "letter_svg__paint5_linear_1265_1198",
    x1: 43.354,
    y1: 138,
    x2: 43.354,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#EEF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#F9FAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "letter_svg__paint6_linear_1265_1198",
    x1: 123.646,
    y1: 138,
    x2: 123.646,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#EEF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#F9FAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "letter_svg__paint7_linear_1265_1198",
    x1: 83.5,
    y1: 77.292,
    x2: 83.5,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "letter_svg__paint8_linear_1265_1198",
    x1: 83.5,
    y1: 62.824,
    x2: 83.5,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "letter_svg__filter0_dddd_1265_1198",
    x: 0.271,
    y: 17.563,
    width: 166.458,
    height: 162.542,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.958
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.958
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1265_1198"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.833
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.917
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1265_1198",
    result: "effect2_dropShadow_1265_1198"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.646
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.896
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_1265_1198",
    result: "effect3_dropShadow_1265_1198"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 29.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.875
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_1265_1198",
    result: "effect4_dropShadow_1265_1198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect4_dropShadow_1265_1198",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "letter_svg__filter1_f_1265_1198",
    x: 11.504,
    y: 16.71,
    width: 141.539,
    height: 79.055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.896,
    result: "effect1_foregroundBlur_1265_1198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "letter_svg__filter2_di_1265_1198",
    x: 11.042,
    y: 38.125,
    width: 75.329,
    height: 113.583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.833,
    dy: 3.917
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.896
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1265_1198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1265_1198",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.979
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_1265_1198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "letter_svg__filter3_di_1265_1198",
    x: 80.629,
    y: 38.125,
    width: 75.329,
    height: 113.583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.833,
    dy: 3.917
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.896
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1265_1198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1265_1198",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.979
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_1265_1198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "letter_svg__filter4_f_1265_1198",
    x: 12.021,
    y: 76.073,
    width: 142.958,
    height: 65.844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.958,
    result: "effect1_foregroundBlur_1265_1198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "letter_svg__filter5_f_1265_1198",
    x: 12.021,
    y: 63.564,
    width: 142.958,
    height: 86.186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.875,
    result: "effect1_foregroundBlur_1265_1198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "letter_svg__filter6_f_1265_1198",
    x: -7.563,
    y: 45.695,
    width: 182.125,
    height: 115.805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.75,
    result: "effect1_foregroundBlur_1265_1198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "letter_svg__filter7_i_1265_1198",
    x: 13,
    y: 79.796,
    width: 141,
    height: 58.205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.979
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_1265_1198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "letter_svg__filter8_f_1265_1198",
    x: -2.667,
    y: 54.281,
    width: 172.333,
    height: 99.385,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.917,
    result: "effect1_foregroundBlur_1265_1198"
  })))));
}
export default SvgLetter;